<template>
  <div
    :width="getWidth"
    :height="getHeight"
    class="media-container"
    @click="mediaClicked">

    <div
      v-if="!mediaLoaded"
      class="spinner-container">

      <q-icon
        :allowSelfUpdate="false"
        spin
        class="spinner"
        name="spinner" />

    </div>
    <img
      v-else
      :width="getWidth"
      :height="getHeight"
      :src="dataUrl" />

  </div>
</template>

<script>
import QIcon from '@/components/standard/display/QIcon'

export default {
  data () {
    return {
      promise: null,
      xhr: null,
      dataUrl: null
    }
  },

  methods: {
    /**
     * Emits a click event
     */
    mediaClicked () {
      this.$emit('click', this.mediaObject)
    },

    /**
     * Converts blob to DataURL
     * @param {Blob} blob
     * @param {Callback} callback
     */
    blobToDataURL (blob, callback) {
      var a = new FileReader()
      a.onload = function(e) {
        let rtr = {
          dataUrl: e.target.result
        }
        callback(rtr)
      }

      a.readAsDataURL(blob)
    },

    /**
     * Loads an image, by opening a promise and a xhhtp request
     * @param {Url} url Image's URL
     */
    loadImage (url) {
      var loadedImage = new Image()
      loadedImage.crossOrigin = ""
      let self = this

      this.promise = this.openPromise(url)
        .then(function (response) {
          let imageURL = window.URL.createObjectURL(response)
          loadedImage.src = imageURL

          // Make a dataURL from blob
          let callback = (e) => {
            let { dataUrl } = e
            self.dataUrl = dataUrl
          }

          self.blobToDataURL(response, callback)
      }, function (Error) {
          console.error(Error)
      })
    },

    /**
     * Openes a xhttp request
     * @param {String} url
     */
    openPromise (url) {
      let self = this
      return new Promise(function (resolve, reject) {
        let request = new XMLHttpRequest()
        self.$set(self, 'xhr', request)
        request.open('GET', url)
        request.responseType = 'blob'

        request.onload = function () {
          // Check status
          if (request.status === 200) {
            resolve(request.response)
          } else {
            reject(new Error('Image didn\'t load successfully; error code:' + request.statusText))
          }
        }

        request.onerror = function () {
            reject(new Error('There was a network error.'))
        }

        // Send the request
        request.send()
      })
    }

  },

  computed: {
    getSize () {
      return this.size
    },

    getWidth () {
      return this.getSize.width || 'auto'
    },

    getSpinnerSize () {
      return '10%'
    },

    getHeight () {
      return this.getSize.height || 'auth'
    },

    getSrc () {
      if (this.src) return this.src
      return require(`!!url-loader!@/assets/images/${this.asset}`)
    },

    mediaLoaded () {
      return !!this.dataUrl
    }
  },

  mounted () {
    this.loadImage(this.getSrc)
  },

  beforeDestroy() {
    this.xhr.abort()
  },

  props: {
    size: {
      type: Object,
      required: false,
      default: () => { {} }
    },

    src: {
      type: String,
      required: false,
      default: ''
    },

    asset: {
      type: String,
      required: false,
      default: ''
    },

    mediaObject: {
      type: Object,
      required: true,
      default: () => { {} }
    }
  },

  components: {
    'q-icon': QIcon
  }
}
</script>

<style scoped>
.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-container .spinner {
  width: 100%;
  max-width: 100px;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/display/Media.vue?446f4429